import {get} from 'lodash/fp';

import {Rank} from '/constant/TestIDs';
import {
  INTEGRATED_GLOBAL_DIRECTOR,
  INTEGRATED_PRESIDENTIAL_DIRECTOR,
} from '/enum/rank.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {showComingSoonToast} from '/util/toast.util';

import PeopleData from '../../PeopleData';
import PeopleExtendedData from '../../PeopleExtendedData';
import {PersonStats} from '../personStats';

const tt = (key: any, value: any) =>
  withTranslation.tt(`rankProgressCard.fibcTeams.${key}`, value);

export default {
  dataComponent: PeopleData,
  dataComponentProps: {
    getPeople: get('coaches'),
    getTitle: (target: any) => {
      return target <= 1
        ? tt('title.incomplete.singular', 'FIBC Team')
        : tt('title.incomplete.plural', 'FIBC Teams');
    },
    personIsCoach: true,
  },
  extendedDataComponent: PeopleExtendedData,
  extendedDataComponentProps: {
    getPeople: get('coaches'),
    personIsCoach: true,
    getVacantName: () => tt('vacancyPosition', 'FIBC'),
    getVacancyCta: () => tt('vacancyCta', 'See Who’s Close To FIBC'),
    getPersonDescription: () => tt('position', 'Integrated Business Coach'),
    getPersonStats: (data: any) =>
      PersonStats(
        {
          subheaderFirst: tt('seniorCoachTeams', 'Senior Coach Teams'),
          subheaderSecond: tt('gqv', 'GQV'),
          count: data.seniorCoachTeamsCount,
          target: data.seniorCoachTeamsTarget,
        },
        // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
        ...data,
      ),
    onVacancyCtaPress: () =>
      showComingSoonToast('rank progress close to fibc rank'),
  },
  isComplete: ({currentCount: current, target}: any) => current >= target,
  hasExtendedDetail: true,
  presentedFor: [INTEGRATED_GLOBAL_DIRECTOR, INTEGRATED_PRESIDENTIAL_DIRECTOR],
  testID: Rank.rankFIBCTeams,
};
